import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "q-my-none" }
const _hoisted_2 = {
  key: 0,
  class: "q-my-none"
}
const _hoisted_3 = {
  key: 1,
  class: "q-my-none"
}
const _hoisted_4 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  width: "100%",
  height: "100%",
  fill: "currentcolor"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]

import { useQuasar } from 'quasar';
import { ref, toRefs, watch } from 'vue';

// Personal libs
import { tailleFichier } from '@shared/lib/tools.lib';

/**
 * Globals
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'QProgressBar',
  props: {
  pbDescription: { type: String, required: true },
  pbShowDescription: { type: Boolean, required: false, default: false },
  pbCurrentValue: { type: Number, required: true },
  pbMax: { type: Number, required: true, default: 0 },
  isUploader: { type: Boolean, required: false, default: false },
},
  setup(__props) {

// Inspired by https://www.w3.org/WAI/ARIA/apg/patterns/meter/examples/meter/

// Vendor
const $q = useQuasar();

/**
 * Properties
 */
const props = __props;
const { pbDescription, pbShowDescription, pbCurrentValue, pbMax } =
  toRefs(props);

/**
 * Reactive datas
 */
const percentFill = ref<number>(0);
const styleWidth = ref<string>('0');
const styleColor = ref<string>();

/**
 * Methods
 */

function getColorValue(): string {
  // From red to green
  const hue = (percentFill.value == 0 ? 0 : percentFill.value / 100) * 120;
  return 'hsl(' + hue + ', 100%, 40%)';
}

function progressUpdate() {
  if (pbCurrentValue.value != 0 && pbMax.value != 0) {
    // update fill width
    percentFill.value = (100 * (pbCurrentValue.value - 0)) / (pbMax.value - 0);
    styleWidth.value = (percentFill.value ?? 0) + '%';
    styleColor.value = getColorValue();
  } else {
    styleWidth.value = '100%';
    styleColor.value = $q.dark.isActive
      ? 'hsl(0, 100%, 0%)'
      : 'hsl(0, 100%, 100%)';
  }
}

/**
 * Watch
 */
watch(
  () => pbCurrentValue.value,
  () => {
    progressUpdate();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "upload_progress",
      class: _normalizeClass({ 'sr-only': !_unref(pbShowDescription) })
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(pbDescription)), 1 /* TEXT */),
      (_unref(pbMax) > 0 && __props.isUploader)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(tailleFichier)(_unref(pbCurrentValue))) + " / " + _toDisplayString(_unref(tailleFichier)(_unref(pbMax))) + " (" + _toDisplayString(Math.round(percentFill.value)) + "%) ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_unref(pbMax) > 0 && !__props.isUploader)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(pbCurrentValue)) + " / " + _toDisplayString(_unref(pbMax)) + " (" + _toDisplayString(Math.round(percentFill.value)) + "%) ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      role: "meter",
      "aria-valuemin": "0",
      "aria-valuenow": _unref(pbCurrentValue),
      "aria-valuemax": _unref(pbMax),
      "aria-labelledby": "upload_progress",
      class: _normalizeClass(_unref($q).dark.isActive ? 'border-color-white' : 'border-color-black')
    }, [
      (_openBlock(), _createElementBlock("svg", {
        style: _normalizeStyle(`width: ${styleWidth.value}; color: ${styleColor.value};`),
        class: "fill",
        "aria-hidden": "true",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_6, 4 /* STYLE */))
    ], 10 /* CLASS, PROPS */, _hoisted_4)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})